<template>
	<p class="form-rate__total">По текущему курсу: <span>{{convertedAmount}}</span></p>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		computed: {
			...mapState({
				convertedAmount: state => state.indexes.convertedAmount
			})
		}
	}
</script>
